import { useGetBillingPastSubscriptionAmounts } from "@src/api/billing-modules/past-subscription-amounts";
import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";

import {
  buildPastSubscriptions,
  type PastSubscriptionPaidAmount,
} from "./internal/pastSubscriptions";
import type { BillingPastSubscriptionViewModel } from "./types";

export const useBillingPastSubscriptions = ({
  includePaidAmounts = false,
}: { includePaidAmounts?: boolean } = {}): {
  pastSubscriptions: BillingPastSubscriptionViewModel[];
} => {
  const { data: orgSummary } = useGetOrganizationSummary();
  const paidAmounts = useGetBillingPastSubscriptionAmounts(orgSummary.org.id, {
    enabled: includePaidAmounts,
  });

  const paidAmountsBySubscriptionId = Object.fromEntries(
    (paidAmounts.data?.amounts ?? []).map(
      (entry): [string, PastSubscriptionPaidAmount] => [
        entry.stripeSubscriptionId,
        { amountPaidCents: entry.amountPaidCents },
      ]
    )
  );

  return {
    pastSubscriptions: buildPastSubscriptions({
      organizationSubscriptions: orgSummary.org.organizationSubscriptions,
      stripeSubscriptionSummaries: orgSummary.org.stripeSubscriptionSummaries,
      paidAmountsBySubscriptionId,
      isPaidAmountsLoading: paidAmounts.isLoading,
    }),
  };
};
